<section
    [class.p-4]="!onlyItems()"
    class="relative flex flex-col gap-3 overflow-x-visible"
>
    @if (!onlyItems()) {
        @if (serviceOpen() && isRequiredDocumentWrite()) {
            <app-document-select-ticket
                (clickOutside)="handleToggleServiceOpen()"
                animate.enter="fade-in"
                animate.leave="fade-out"
                class="absolute lg:left-[100%] left-0 top-0 z-50 shadow-md rounded-xl lg:min-w-[25rem] w-full lg:w-auto bg-white"
            />
        }
        <app-input
            icon="mdi:search"
            placeholder="검색어를 입력해주세요."
            [(value)]="query"
            [debounce]="300"
        />
        <app-segment-tabs [options]="tabOptions" [(value)]="tab" />
    }
    <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-3">
            @for (i of list(); track $index) {
                <app-pre-document-card [params]="i" />
            }
        </div>
        @if (!onlyItems()) {
            <div class="flex flex-col gap-6">
                <p class="text-center text-gray-500 text-sm">
                    필수문서 작성 후, 서비스 선택이 가능합니다.
                </p>
                @if (isRequiredDocumentWrite()) {
                    <div class="bg-gray-200 w-full h-px"></div>
                    <app-button expand (click)="handleToggleServiceOpen()"
                        >서비스 선택</app-button
                    >
                }
            </div>
        }
    </div>
</section>
